var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuilding11(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M853.333333 170.666667H170.666667L142.222222 56.888889h739.555556zM199.111111 227.555556v739.555555h256v-170.666667h113.777778v170.666667h256V227.555556H199.111111z m199.111111 512h-113.777778v-113.777778h113.777778v113.777778z m0-170.666667h-113.777778v-113.777778h113.777778v113.777778z m0-170.666667h-113.777778v-113.777778h113.777778v113.777778z m170.666667 341.333334h-113.777778v-113.777778h113.777778v113.777778z m0-170.666667h-113.777778v-113.777778h113.777778v113.777778z m0-170.666667h-113.777778v-113.777778h113.777778v113.777778z m170.666667 341.333334h-113.777778v-113.777778h113.777778v113.777778z m0-170.666667h-113.777778v-113.777778h113.777778v113.777778z m0-170.666667h-113.777778v-113.777778h113.777778v113.777778z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding11);
export default __webpack_public_path__ + "static/media/building-11.3b5992f02940324a9c16e03d86d61119.svg";
export { ForwardRef as ReactComponent };